import React from 'react';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import { useState } from 'react';
import { Firebase } from '../components/config';
import { useNavigate } from 'react-router-dom'
import { useForm ,Controller} from "react-hook-form";
import Alert from 'react-bootstrap/Alert';

import '../cssfiles/animation.css'
import ButtonExample from '../components/loadsubmit'
import '../cssfiles/Login.css'




function Signup() {
 const [loading, setLoading] = useState(false)

  const {
    register,
    control,
    handleSubmit,
    formState: { errors },
    reset,
    trigger,
  } = useForm({
    defaultValues: {
      checkbox: false,
    }
  });



  const navigate = useNavigate()

  const onSubmit = (data) => {
    setLoading(true)
    setTimeout(() => {
      setLoading(false)
    }, 5000);
  console.log(data)
    const Email = data.email
    const Password = data.password
    const First = data.firstname
    const Second = data.secondname
    Firebase.auth().createUserWithEmailAndPassword(Email, Password).then((userCredential) => {

      userCredential.user.updateProfile({ displayName: First }).then(() => {
        Firebase.firestore().collection('user').add({
          id:userCredential.user.uid,
          First:First,
          Second:Second
        }).then(
          navigate('/Login')
        )


      }).catch((error) => {
        alert(()=>{
          return <Alert variant="danger" dismissible>
          <Alert.Heading>Oh snap! You got an error!</Alert.Heading>
          <p>
            {error.message}
          </p>
        </Alert>
        })
      })
    })
    reset();
  };

  return (
    <div className="area" >
            <ul className="circles">
                    <li></li>
                    <li></li>
                    <li></li>
                    <li></li>
                    <li></li>
                    <li></li>
                    <li></li>
                    <li></li>
                    <li></li>
                    <li></li>
                    <li></li>
                    <li></li>
                    <li></li>
                    <li></li>
                    <li></li>
                    <li></li>
                    <li></li>
                    <li></li>
                    <li></li>
                    <li></li>
                
            </ul>
    <div className='position'>






      <Form  id= "textBox" onSubmit={handleSubmit(onSubmit)}>
        <div className='centertext'><h1>SIGN UP</h1></div>

        <Form.Label>First Name</Form.Label>

        <Form.Control type="text" placeholder="First Name"
         className={`form-control ${errors.firstname && "invalid"}`}
          {...register("firstname", { required: " First Name is Required", pattern: {
            value: /^([A-Za-z])+$/,
            message: "Mandatory single name, WITHOUT spaces, WITHOUT special characters",
          },minLength: {
            value: 2,
            message: "Minimum Required length is 3",
          },
          maxLength: {
            value: 10,
            message: "Maximum allowed length is 10 ",
          }
          })}
          onKeyUp={() => {
            trigger("firstname");
          }} />

        {errors.firstname && (
          <small className="text-danger">{errors.firstname.message}</small>
        )}

        <div><Form.Label>Second Name</Form.Label>
        <Form.Control type="text" placeholder="Second Name" 
          className={`form-control ${errors.secondname && "invalid"}`}
          {...register("secondname", { required: " Second Name is Required",minLength: {
            value: 2,
            message: "Minimum Required length is 3",
          },
          maxLength: {
            value: 10,
            message: "Maximum allowed length is 12 ",
          } })}
          onKeyUp={() => {
            trigger("secondname");
          }} />

        {errors.secondname && (
          <small className="text-danger">{errors.secondname.message}</small>
        )}
</div>
        <Form.Label>Email address</Form.Label>
        <Form.Group className="mb-3 " controlId="formBasicEmail">
          <Form.Control type="email" placeholder="Enter email"  
            className={`form-control ${errors.email && "invalid"}`}
            {...register("email", {
              required: "Email is Required",
              pattern: {
                value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                message: "Invalid email address",
              }
            })}
            onKeyUp={() => {
              trigger("email");
            }} />

          {errors.email && (
            <small className="text-danger">{errors.email.message}</small>
          )}

        </Form.Group>
        <Form.Group className="mb-3 " controlId="formBasicPassword ">
          <Form.Label>Password</Form.Label>
          <Form.Control type="password" placeholder="Password" 
           className={`form-control ${errors.password && "invalid"}`}
            {...register("password", {
              required: "Password is Required",
              pattern: {
                value: /^.*(?=.{6,})(?=.*[a-zA-Z])(?=.*\d)(?=.*[!&$%&?@ "]).*$/,
                message: "Invalid password",
              },maxLength: {
                value: 12,
                message: "Maximum allowed length is 12 ",
              }
            })}
            onKeyUp={() => {
              trigger("password");
            }} />

          {errors.password && (
            <small className="text-danger">{errors.password.message}</small>
          )}

        </Form.Group>
        <Form.Group className={`form-control ${errors.checkbox && "invalid"}`} controlId="formBasicCheckbox ">
        <Controller name="checkbox"
        
        control={control}
        rules={{ required: "checkbox is Required"}}
        render={({ field }) => <Form.Check type="checkbox" label="Agree to terms and conditions" {...field} />}
        
        />{errors.checkbox && (
          <small className="text-danger">{errors.checkbox.message}</small>
        )}
        </Form.Group>
        { loading ? <ButtonExample/>
        :<Button variant="dark" type='submit'>
          SUBMIT
        </Button>}
      </Form>



    </div></div>
  )
}

export default Signup